import { render, staticRenderFns } from "./NAppEditableComment.vue?vue&type=template&id=785b9888&"
import script from "./NAppEditableComment.vue?vue&type=script&lang=js&"
export * from "./NAppEditableComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports